"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var isUndefined = function isUndefined(value) {
  return typeof value === 'undefined';
};

var _default = isUndefined;
exports.default = _default;